import { MessageBrokerUtils } from "../utils";
import { useEffect } from "react";
import { Channel, Topic } from "../constants";

export const useAppContainerReady = data => {
  useEffect(() => {
    if (data) {
      appContainerReady(data);
    }
  }, [data]);

  const appContainerReady = data => {
    MessageBrokerUtils.publish({
      channel: Channel.UI,
      topic: Topic.appContainerReady,
      headers: {
        publisher: "UAA"
      },
      data
    });
  };
};
